module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sidebarCurrentPanel === 'modifiers'),
      expression: "sidebarCurrentPanel === 'modifiers'"
    }],
    staticClass: "kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open"
  }, [_c('div', {
    staticClass: "kp-modular-tab pt-page no-fade pt-page-current"
  }, [_c('header', {
    staticClass: "kp-modular-title"
  }, [_vm._v("\n        Configurações\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "submenu-content sub-color"
  }, [_c('header-config'), _vm._v(" "), _vm._l((_vm.subItems), function(subItem) {
    return _c('div', {
      staticClass: "kp-list-group-item clearfix"
    }, [_c('label', {
      staticClass: "kp-row box-title box-title__button",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.sidebarSetElement(subItem)
        }
      }
    }, [_vm._v("\n            " + _vm._s(subItem.getAttribute('klickbox-edit-label')) + "\n            "), _vm._m(0, true)]), _vm._v(" "), _c('span')])
  }), _vm._v(" "), _c('div', {
    staticClass: "submenu-padding"
  }, _vm._l((_vm.modifiers), function(modifier) {
    return _c('div', [_c('editor', {
      attrs: {
        "modifier": modifier,
        "general": _vm.stepPreview.isGeneral,
        "item": _vm.item
      }
    })], 1)
  }), 0)], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticClass: "btn is-circular has-icon"
  }, [_c('i', {
    staticClass: "fa fa-cog"
  })])])
}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-d96dc1a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/modifiers/Main.vue
 ** module id = 913
 ** module chunks = 1
 **/